import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SEO from '../components/SEO';
import '../styles/LegalPages.css';

const SecurityStatement = () => {
  // Scroll to top on mount - immediate
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="legal-page">
      <SEO canonical="/security-statement" />
      <header className="legal-header">
        <div className="container">
          <Link to="/" className="legal-back-link">
            <ArrowLeft size={18} />
            <span>Back to Home</span>
          </Link>
          <Link to="/" className="legal-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_accordion-repair/artifacts/06uiebgi_Variant%201_Full%20Logo_Vector%20copy%202.png" 
              alt="All Secured" 
            />
          </Link>
        </div>
      </header>

      <main className="legal-content">
        <div className="container">
          <article className="legal-article">
            <h1>Security Statement</h1>
            <p className="legal-effective-date">Our Commitment to Security</p>

            <section>
              <p>At All Secured, security is foundational to our platform. We implement:</p>
              <ul>
                <li>HTTPS encryption across the site</li>
                <li>Secure password hashing</li>
                <li>Token-based login authentication</li>
                <li>Strict access controls for administrative users</li>
                <li>Stripe-hosted payment processing</li>
                <li>No storage of card details</li>
                <li>Regular monitoring of webhook and transaction logs</li>
              </ul>
            </section>

            <section>
              <h2>Platform Protections</h2>
              <ul>
                <li>Server-side authorization checks</li>
                <li>Idempotent payment webhooks</li>
                <li>Time-limited single-use authentication tokens</li>
                <li>Role-based admin access controls</li>
              </ul>
            </section>

            <section>
              <h2>What We Do Not Do</h2>
              <ul>
                <li>We do not store full payment card details</li>
                <li>We do not sell personal data</li>
                <li>We do not allow public access to course materials</li>
              </ul>
            </section>

            <section>
              <h2>Your Role</h2>
              <p>Security is shared. Users should:</p>
              <ul>
                <li>Use strong passwords</li>
                <li>Keep login details private</li>
                <li>Report suspicious activity immediately</li>
              </ul>
            </section>
          </article>
        </div>
      </main>

      <footer className="legal-footer">
        <div className="container">
          <p>&copy; 2025 All Secured. All rights reserved.</p>
          <p className="legal-footer-stripe">Secure payments powered by Stripe.</p>
        </div>
      </footer>
    </div>
  );
};

export default SecurityStatement;
